<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{ $lang('在线文档') }}</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST, OPEN_API_PRO} from '@/constants'

const apiUrlTest = 'logistics/trace';
export default {
  components: {onlineDoc, apiTestDoc},
  data() {
    const that = this
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: that.$lang("通过单号查询快件的轨迹信息"),
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: "apiAccount",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang("接入方在平台的api账户标识")
              },
              {name: "digest", type: "String", require: "Y", normal: "", describe: that.$lang("签名字符串,请在签名工具内获取")},
              {
                name: "timestamp",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang('时间戳，毫秒') + "<br/>" + that.$lang('时区：UTC+7'),
                isHtml: true
              },
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: "bizContent",
                type: "String",
                require: "Y",
                normal: that.$lang("业务参数"),
                describe: that.$lang("业务参数模块内json格式的string类型")
              },
            ]
          },
          {
            title: "业务参数",
            value: [
              {
                name: "customerCode",
                type: "String(30)",
                require: "Y",
                normal: "084LC02000",
                describe: that.$lang('客户编码（客户合作网点提供）')
              },
              {
                name: "password",
                type: "String",
                require: "Y",
                normal: that.$lang('明文密码：H5CD3zE6'),
                describe: that.$lang('客户资料提供的开平账号密码')
              },
              {
                name: "txlogisticId",
                type: "String",
                require: "Y",
                normal: "TESTID000001",
                describe: that.$lang('Customer Order ID客户订单号') + '<br/>' + that.$lang('不支持重复'),
                isHtml: true
              },
              {
                name: "billcodes",
                type: "String(500)",
                require: "Y",
                normal: "",
                describe: that.$lang('运单号') + '<br/>' + that.$lang('多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单'),
                isHtml: true
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: "code",
                type: "String(10)",
                require: "Y",
                normal: "1",
                describe: that.$lang('是否成功') + '<br/>' + that.$lang('1为成功，其他为失败，此时关注msg中返回的失败原因'),
                isHtml: true,
              },
              {name: "msg", type: "String(100)", require: "Y", normal: "success", describe: that.$lang('返回信息')},
              {
                name: "data", type: "Object", require: "Y", normal: "", describe: that.$lang('业务数据'), children: [
                  {name: "billCode", type: "String(30)", require: "Y", normal: '', describe: that.$lang('运单号')},
                  {
                    name: "details",
                    type: "Object | Array",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('轨迹详情'),
                    children: [
                      {name: "scanTime", type: "String", require: "Y", normal: "", describe: that.$lang('扫描时间')},
                      {name: "desc", type: "String", require: "Y", normal: "", describe: that.$lang('轨迹描述')},
                      {name: "scanTypeCode", type: "int", require: "Y", normal: "106：" +  that.$lang('已取件'), describe: that.$lang('扫描类型编码，扫描类型') + '<br/>' + 'COLLECTION(10,"' + that.$lang('快件揽收') + '"),' + '<br/>' + 'SEND(50, "' + that.$lang('发件扫描') + '"),' + '<br/>' + 'ARRIVAL(92, "' + that.$lang('到件扫描') + '"),' + '<br/>' + 'DELIVERY(94, "' + that.$lang('出仓扫描') + '"),' + '<br/>' + 'SIGN(100, "' + that.$lang('快件签收') + '"),' + '<br/>' + 'RETURN_PARCEL(176, "' + that.$lang('退件扫描') + '"),' + '<br/>' + 'RETURN_SIGN(173, "' + that.$lang('退件签收') + '"),' + '<br/>' + 'ISSUE(110, "' + that.$lang('问题件扫描') + '")', isHtml: true },
                      {
                        name: "scanTypeName",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描类型'),
                        isHtml: true
                      },
                      {
                        name: "scanNetworkName",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描网点名称')
                      },
                      {
                        name: "scanNetworkId",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描网点ID')
                      },
                      {name: "staffName", type: "String", require: "Y", normal: "", describe: that.$lang('业务员姓名')},
                      {
                        name: "staffContact",
                        type: "String",
                        require: "N",
                        normal: "",
                        describe: that.$lang('业务员联系方式')
                      },
                      {
                        name: "scanNetworkContact",
                        type: "String",
                        require: "N",
                        normal: "",
                        describe: that.$lang('扫描网点联系方式')
                      },
                      {
                        name: "scanNetworkProvince",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描网点省份')
                      },
                      {
                        name: "scanNetworkCity",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描网点城市')
                      },
                      {
                        name: "scanNetworkArea",
                        type: "String",
                        require: "Y",
                        normal: "",
                        describe: that.$lang('扫描网点区/县')
                      },
                      {
                        name: "pictureUrl",
                        type: "Array",
                        require: "N",
                        normal: "",
                        describe: that.$lang('图⽚（签收证明图片 - 签收扫描时，展示该数据；问题件扫描图片 - 问题件扫描时展示该数据）')
                      },
                    ]
                  }
                ]
              },
            ]
          }
        ],
        //请求示例
        requestCode: JSON.parse(`{"billCodes":"842800765741","txlogisticId":"","customerCode":"024E000014","password":"FbuEF5bDUc65+TN0HxnO+g=="}`),
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success","data":[{"billCode":"842800765741","details":[{"scanTime":"2024-06-05 15:57:04","desc":"Kiện hàng đã được ký, người nhận là【】，BC phát【(HCM) Mai Thị Lựu】，Nhân viên phát kiện là【028A0261374-Huỳnh Bửu Nhi(+84903145363)】","scanTypeCode":100,"scanTypeName":"Ký nhận","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"staffName":"Huỳnh Bửu Nhi","staffContact":"+84903145363","scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106","pictureUrl":["https://hcm03.vstorage.vngcloud.vn/uat-jmsvn-file/mic180low/yl-web-jmsvn-app-bc/scan_sign/20240605/9J8jferGwl_/data/user/0/com_jt_express_vietnam_outfield/files/def_1717574219916.png?response-content-type=%2A%2F%2A&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cc2c1d0ad16f50b2b51e8f62731e955a%2F20240619%2FHCM03%2Fs3%2Faws4_request&X-Amz-Date=20240619T064451Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=cef7409a162ac8ee1bb5315d9bc146d5e0ecf03e5b99d03c473aecd4e48ac7ba"]},{"scanTime":"2024-06-05 15:56:43","desc":"【(HCM) Mai Thị Lựu】nhân viên phát hàng【028A0261374-Huỳnh Bửu Nhi(02873081088-1067)】đang phát hàng, nhân viên thao tác【028A0261374-Huỳnh Bửu Nhi】","scanTypeCode":94,"scanTypeName":"Quét phát hàng","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"staffName":"Huỳnh Bửu Nhi","staffContact":"02873081088-1067","scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106"},{"scanTime":"2024-06-05 15:56:24","desc":"【(HCM) Mai Thị Lựu】đã quét mã bất thường, nhân viên quét mã【028A0261374-Huỳnh Bửu Nhi】，Nguyên nhân vấn đề【】","scanTypeCode":110,"scanTypeName":"Quét kiện vấn đề","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106","pictureUrl":["https://hcm03.vstorage.vngcloud.vn/uat-jmsvn-file/mic180low/yl-web-jmsvn-app-bc/scan_problem/20240605/yrymVUQor9_/data/user/0/com_jt_express_vietnam_outfield/files/def_1717574180113.png?response-content-type=%2A%2F%2A&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cc2c1d0ad16f50b2b51e8f62731e955a%2F20240619%2FHCM03%2Fs3%2Faws4_request&X-Amz-Date=20240619T064451Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=8c7fe35350358b05905d84e3f4075a0459965048f1d7b5b131fc2f889371461d"]},{"scanTime":"2024-06-05 15:54:03","desc":"Chuyển phát nhanh đến【(HCM) Mai Thị Lựu】trạm trước là【【(HCM) Mai Thị Lựu】，Trọng lượng là【】","scanTypeCode":92,"scanTypeName":"Hàng đến","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106","nextStopName":"(HCM) Mai Thị Lựu"},{"scanTime":"2024-06-05 15:40:24","desc":"【(HCM) Mai Thị Lựu】nhân viên phát hàng【0848882019-Mật khẩu là Aa123456(02873081088-1067)】đang phát hàng, nhân viên thao tác【028A0261374-Huỳnh Bửu Nhi】","scanTypeCode":94,"scanTypeName":"Quét phát hàng","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"staffName":"Mật khẩu là Aa123456","staffContact":"02873081088-1067","scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106"},{"scanTime":"2024-06-05 15:40:18","desc":"Chuyển phát nhanh đến【(HCM) Mai Thị Lựu】trạm trước là【【(HCM) Mai Thị Lựu】，Trọng lượng là【】","scanTypeCode":92,"scanTypeName":"Hàng đến","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106","nextStopName":"(HCM) Mai Thị Lựu"},{"scanTime":"2024-06-05 15:40:11","desc":"Hàng chuyển nhanh tại【(HCM) Mai Thị Lựu】do【028A0261374-Huỳnh Bửu Nhi】quét khứ hồi【(BGG) 522 Lê Lợi】，số công việc【】，Biển số【】","scanTypeCode":50,"scanTypeName":"Gửi hàng","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106","nextStopName":"(BGG) 522 Lê Lợi"},{"scanTime":"2024-06-05 15:40:05","desc":"【(HCM) Mai Thị Lựu】Nhân viên【028A0261374-Huỳnh Bửu Nhi(+84903145363)】Đã nhận hàng","scanTypeCode":10,"scanTypeName":"Nhận hàng","scanNetworkTypeName":"一级网点","scanNetworkName":"(HCM) Mai Thị Lựu","scanNetworkId":7860,"staffName":"Huỳnh Bửu Nhi","staffContact":"+84903145363","scanNetworkProvince":"Hồ Chí Minh","scanNetworkCity":"Quận 1","scanNetworkArea":"Phường Đa Kao-028QQ106"}]}]}`),
      },
      apiTestData: {
        _headerData: {
          apiAccount: "1001",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data: {
          bizContent: `{"billCodes":"UT0000352320970,UT0000359748995,UT0000353613157"}`,
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [
          {code: '145003100', msg: "运单号非法"},
          {code: '145003502', msg: "运单号个数超过30"}]
      },
    };
  },
  created() {
  },
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
